import type { TenantLicenseDetailResponse } from '@/services/licenseTypes'
import { licenseAdminApi } from '@/services/licenseAdminApi'
import { runWithToast } from '@/helpers/asyncToast.helper'

interface LicenseIssuedPanelProps {
	detail: TenantLicenseDetailResponse
	onClose: () => void
}

const LicenseIssuedPanel = ({ detail, onClose }: LicenseIssuedPanelProps) => {
	const onResend = () => runWithToast(() => licenseAdminApi.resendEmail(detail.id))

	return (
		<div className="issue-license-modal py-2 text-center sm:text-left">
			<div className="issue-license-modal__success-icon">
				<i className="ri-checkbox-circle-fill" aria-hidden />
			</div>
			<h3 className="text-lg font-semibold text-foreground text-center sm:text-left">License issued successfully</h3>
			<p className="mt-1 text-sm text-[hsl(var(--muted-foreground))] text-center sm:text-left">
				An email with activation details was sent to <strong className="text-foreground">{detail.adminEmail}</strong>.
			</p>

			<div className="issue-license-modal__summary mt-5 justify-center sm:justify-start">
				<span className="issue-license-modal__summary-chip">
					<i className="ri-building-2-line" aria-hidden />
					{detail.tenantName}
				</span>
				<span className="issue-license-modal__summary-chip">
					<i className="ri-price-tag-3-line" aria-hidden />
					{detail.planName}
				</span>
				<span className="issue-license-modal__summary-chip">
					<i className="ri-calendar-line" aria-hidden />
					{new Date(detail.startedOn).toLocaleDateString()} - {new Date(detail.expiresOn).toLocaleDateString()}
				</span>
			</div>

			{detail.licenseKey ? (
				<div className="mt-5 text-left">
					<label className="issue-license-modal__label flex items-center gap-1">
						<i className="ri-shield-keyhole-line text-primary" aria-hidden />
						License key
						<span className="font-normal text-[hsl(var(--muted-foreground))]">— copy now, shown once</span>
					</label>
					<pre className="mt-2 max-h-36 overflow-auto rounded-[0.75rem] border border-[hsl(var(--border))] bg-[hsl(var(--background))] p-3 text-left text-xs leading-relaxed break-all text-foreground">
						{detail.licenseKey}
					</pre>
					<div className="mt-3 flex flex-wrap gap-2 justify-center sm:justify-start">
						<button type="button" className="btn btn-sm btn-ember" onClick={() => navigator.clipboard.writeText(detail.licenseKey!)}>
							<i className="ri-file-copy-line" aria-hidden />
							Copy key
						</button>
						<button type="button" className="btn btn-sm btn-ember-outline" onClick={onResend}>
							<i className="ri-mail-send-line" aria-hidden />
							Resend email
						</button>
					</div>
				</div>
			) : (
				<p className="mt-4 text-sm text-[hsl(var(--muted-foreground))]">
					License is active. Use resend email if the customer did not receive their key.
				</p>
			)}

			<div className="mt-6 flex justify-center sm:justify-end">
				<button type="button" className="btn btn-ember min-w-[8rem]" onClick={onClose}>
					Done
				</button>
			</div>
		</div>
	)
}

export default LicenseIssuedPanel
